
import InfoCard from "../components/InfoCard/InfoCard"
import { useEffect, useState } from "react";

const InvasionContainer = ({}) => {

    const [invasion, setInvasion] = useState([]);
  
    useEffect(() => {
      fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/invasion.json")
        .then((res) => res.json())
        .then((data) => setInvasion(data))
        .catch((err) => console.error("Error cargando bosses.json:", err));
    }, []);

  return (
    <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 columnas iguales
        gap: "10px", // espacio entre cartas
        width: "100%"}}>
        {invasion.map((inva) =>(
            <InfoCard
                key={inva.name}
                imgSrc={inva.img}
                spanTag="Invasión"
                name={inva.name}
                mapRespawn={inva.map}
                drop={inva.drop}
                respawnTime = {inva.respawn}
                color="rgba(51, 54, 248, 1)"
                qty= {inva.qty}
            />
        ))
        }
    </div>
  )

}

export default InvasionContainer